export const ProcessType = {
  MAIN_PROCESS: { val: 2, name: 'process' },
  POST_PROCESS: { val: 3, name: 'post_process' },
  PRODUCT_REQUIREMENTS: { val: 4, name: 'production_requirement' },
};
